import { render, staticRenderFns } from "./search-input.vue?vue&type=template&id=56636063&scoped=true"
import script from "./search-input.vue?vue&type=script&lang=ts"
export * from "./search-input.vue?vue&type=script&lang=ts"
import style0 from "./search-input.vue?vue&type=style&index=0&id=56636063&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56636063",
  null
  
)

export default component.exports